import { ReportFilter } from 'types';
import { useReportFilters } from '../../../../hooks';

export const useExtensionRequestsFilters = (): ReportFilter[] => {
  const {
    consultationTypeIds,
    authorityIds,
    consultationCategoryIds,
    extensionRequestStatusIds,
  } = useReportFilters();

  return [
    consultationTypeIds,
    authorityIds,
    consultationCategoryIds,
    extensionRequestStatusIds,
  ];
};
